import Back from '@/assets/img/back-arrow.png';
export type Props = {
  onBackClick?: () => void;
};
export const Header = ({ onBackClick }: Props) => {
  return (
    <div className="header-comp">
      <img
        alt="back"
        onClick={() => {
          if (onBackClick) {
            onBackClick();
          }
        }}
        src={Back}
        className="profile-back-arrow"
      />
      <div className="header-title">Profile</div>
    </div>
  );
};
